import { render, staticRenderFns } from "./SponsoredRecommendationVideoSearch.vue?vue&type=template&id=2e696b2a&scoped=true"
import script from "./SponsoredRecommendationVideoSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideoSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideoSearch.vue?vue&type=style&index=0&id=2e696b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e696b2a",
  null
  
)

export default component.exports